module.exports = __webpack_public_path__ + "static/media/BadgeHH.05b5b780.svg";